"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMuiListItemSecondaryActionOverrides = function (_a) {
    var spacing = _a.spacing;
    return ({
        root: {
            right: spacing(2),
        },
    });
};
//# sourceMappingURL=MuiListItemSecondaryAction.js.map